import { apiClient } from './apiClient';

export type BillingInterval = 'Monthly' | 'Yearly';

export type SalesProductPriceCapability = {
  capabilityId: string;
  name: string;
  includedQuantity: number;
};

export type SalesProductPrice = {
  id: string;
  name: string;
  currency: string;
  amount: number;
  billingInterval: BillingInterval;
  isActive: boolean;
  sortOrder: number;
  capabilities: SalesProductPriceCapability[];
};

export type SalesProductPriceCapabilityItemPayload = {
  capabilityId: string;
  includedQuantity?: number;
};

export type SalesProductPriceItemPayload = {
  name?: string;
  currency?: string;
  amount: number;
  billingInterval?: BillingInterval;
  isActive?: boolean;
  sortOrder?: number;
  capabilities?: SalesProductPriceCapabilityItemPayload[];
};

export async function getProductPrices(productId: string): Promise<SalesProductPrice[]> {
  const response = await apiClient.get<SalesProductPrice[]>(`/v1/sales/products/${productId}/prices`);
  return response.data;
}

export async function replaceProductPrices(
  productId: string,
  items: SalesProductPriceItemPayload[],
): Promise<void> {
  await apiClient.put(`/v1/sales/products/${productId}/prices`, { items });
}
